<template>
  <v-switch
    :class="compClass"
    :label="label"
    v-model="elValue"
    :disabled="disabled"
    :readonly="readonly"
    :true-value="trueValue"
    :false-value="falseValue"
    hide-details="auto"
  >
    <template slot="label">
      {{ label }}
      <el-tooltip v-if="tooltip" :tooltip="tooltip" />
    </template>
  </v-switch>
</template>

<script>
export default {
  name: 'ElSwitch',
  props: {
    classP: String,
    label: String,
    value: [Object, Boolean, String, Number],
    tooltip: String,
    disabled: Boolean,
    readonly: Boolean,
    required: Boolean,
    need: Boolean,
    trueValue: { type: [Boolean, String, Number], default: undefined },
    falseValue: { type: [Boolean, String, Number], default: undefined },
  },
  computed: {
    elValue: {
      get() {
        return this.value
      },
      set(elValue) {
        this.$emit('input', elValue)
      },
    },
    requiredClass() {
      return (this.required || this.need) && !this.readonly
        ? 'required-input'
        : ''
    },
    isInline() {
      return true
    },
    compClass() {
      return `${this.classP} ${this.requiredClass} ${
        this.isInline ? 'inline' : ''
      }`
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/elementsTheme.scss';
.inline {
  display: inline-block;
}
</style>
